// extracted by mini-css-extract-plugin
export var actionIcon = "_v9-0";